<template>
  <DetailHeader
    v-bind:session="session"
    v-on:open-contact-modal="onOpenModalContact" />
  <RefonteCard>
    <div class="details__container">
      <spinner
        v-if="loading"
        sizes="w-20 h-20"
        thickness="border-8" />

      <div
        v-if="!loading"
        class="h-full">
        <div class="flex flex-col justify-center lg:flex-row">
          <div class="w-full lg:mr-2 lg:w-1/2">
            <session-card
              v-if="session"
              v-bind:open_elearning_question_modal="openElearningQuestionModal"
              v-bind:head_list="session.produits.length > 0"
              v-bind:participant="participant"
              v-bind:session="{
                ...session,
                type: [session.type]
              }" />

            <div
              v-if="isParcoursOrCursus"
              class="-mt-3 ml-2 border-l border-accent-300 pl-4 pt-4 lg:ml-6 lg:pl-6">
              <session-card
                v-for="produit in session.produits"
                v-bind:key="`produit-${produit.reference}`"
                v-bind:session="{
                  ...produit,
                  type: [produit.type],
                  lieuNom:
                    produit.type &&
                    produit.type.id === 1 &&
                    session.sessionLieu &&
                    session.sessionLieu.nom
                }"
                v-bind:go_to_details="go_to_details"
                v-bind:parcours="true" />
            </div>
            <DetailSiteInfo v-bind:site="session.site" />

            <div class="flex flex-col items-center sm:flex-row sm:space-x-4">
              <div
                v-if="session.satisfaction"
                class="mb-3 w-full sm:w-1/2">
                <div
                  v-on:click="openEvaluationModal(session)"
                  class="flex h-full w-full flex-col items-center justify-center rounded-lg bg-yellow-100 p-4 text-center text-lg shadow transition"
                  v-bind:class="{
                    'cursor-pointer hover:bg-yellow-200':
                      !session.satisfaction.dateReponse &&
                      session.satisfaction.id
                  }">
                  <div
                    class="mb-3 text-sm font-bold leading-none text-core-700 xl:text-lg xl:leading-none">
                    Satisfaction
                  </div>

                  <template v-if="session.satisfaction.expire">
                    <div
                      class="flex flex-grow items-center text-lg font-bold leading-none text-blue-900">
                      Non réalisé
                    </div>
                  </template>

                  <div
                    v-else-if="session.satisfaction.dateReponse"
                    class="flex flex-grow items-center text-lg font-bold leading-none text-yellow-600">
                    Réalisé le : {{ session.satisfaction.dateReponse }}
                  </div>

                  <div
                    v-else-if="session.satisfaction.id"
                    class="flex flex-grow items-center text-lg font-bold leading-none text-yellow-600">
                    <font-awesome-icon
                      icon="pen"
                      size="sm" />
                    <span class="mx-3">Saisir ma satisfaction</span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  session.examen &&
                  (session.examen.id ||
                    session.examen.expire ||
                    session.examen.repondu)
                "
                class="mb-3 w-full sm:w-1/2">
                <div
                  v-on:click="openExamenModal(session)"
                  class="flex h-full w-full flex-col items-center justify-center rounded-lg bg-orange-100 p-4 text-center text-lg shadow transition"
                  v-bind:class="{
                    'cursor-pointer hover:bg-orange-200':
                      session.examen.id && !session.examen.termine
                  }">
                  <div
                    class="mb-3 text-sm font-bold leading-none text-core-700 xl:text-lg xl:leading-none">
                    Examen
                  </div>

                  <template v-if="session.examen.expire">
                    <div
                      class="flex flex-grow items-center text-lg font-bold leading-none text-blue-900">
                      Non réalisé
                    </div>
                  </template>
                  <div
                    v-else-if="session.examen.id && !session.examen.termine"
                    class="flex flex-grow items-center text-lg font-bold leading-none text-orange-600">
                    <font-awesome-icon
                      icon="pen"
                      size="sm" />
                    <span class="mx-3">{{
                      session.examen.reponsesJson
                        ? 'Reprendre mon examen'
                        : 'Commencer mon examen'
                    }}</span>
                  </div>
                  <template
                    v-else-if="
                      session.examen.repondu && session.examen.termine
                    ">
                    <div
                      class="flex flex-grow items-center text-lg font-bold leading-none text-blue-900">
                      <span>Note&nbsp;:&nbsp;</span>
                      <span class="tracking-wider">
                        {{ session.examen.nbreBonnesResponses }}/{{
                          session.examen.nbreQuestions
                        }}
                      </span>
                    </div>
                  </template>
                </div>
              </div>
              <div
                class="mb-3 w-full sm:w-1/2"
                v-if="
                  session.testValidation &&
                  (session.testValidation.id || session.testValidation.repondu)
                ">
                <div
                  v-on:click="openValidationAcquisModal(session)"
                  class="flex h-full w-full flex-col items-center justify-center rounded-lg bg-blue-100 p-4 text-center text-lg shadow transition"
                  v-bind:class="{
                    'cursor-pointer hover:bg-blue-200':
                      isTestValidationOuvrable(session)
                  }">
                  <div
                    v-if="
                      session.parcoursTestValidationAcquisSousProduits &&
                      session.testValidation.testIntermediaire
                    "
                    class="mb-3 text-sm font-bold leading-none text-core-700 xl:text-lg xl:leading-none">
                    Test intermédiaire
                  </div>
                  <div
                    v-else
                    class="mb-3 text-sm font-bold leading-none text-core-700 xl:text-lg xl:leading-none">
                    Validation des acquis
                    {{
                      session.testValidation.minBonnesReponses &&
                      session.testValidation.nbreQuestions &&
                      `(Seuil : ${session.testValidation.minBonnesReponses}/${session.testValidation.nbreQuestions})`
                    }}
                  </div>

                  <template
                    v-if="
                      session.testValidation.id &&
                      !session.testValidation.repondu
                    ">
                    <div
                      class="flex flex-grow items-center text-lg font-bold leading-none text-blue-900">
                      <font-awesome-icon
                        icon="pen"
                        size="sm" />
                      <span class="mx-3">Commencer mon test</span>
                    </div>
                    <div
                      v-if="
                        isNewRuleStarted &&
                        session.attestationDureeJoursGeneration &&
                        !(
                          session.parcoursTestValidationAcquisSousProduits &&
                          session.testValidation.testIntermediaire
                        )
                      "
                      class="mt-2.5 space-y-1 rounded-sm border border-blue-300 px-2 py-1 text-left text-xs/tight">
                      <div>
                        À l'issue de la session, si vous réalisez votre test au
                        delà de {{ session.attestationDureeJoursGeneration }}j
                        l'attestation de formation sera automatiquement générée
                        avec la mention
                        <strong
                          >"Résultat de l'évaluation des acquis: non
                          réalisé"</strong
                        >.
                      </div>
                      <div>
                        Au delà de ce délai vous pouvez réaliser le test à titre
                        d'auto évaluation mais l'attestation de formation ne
                        sera pas mise à jour automatiquement.
                      </div>
                    </div>
                  </template>
                  <template
                    v-if="
                      isTestValidationOuvrable(session) &&
                      session.testValidation.repondu
                    ">
                    <div
                      class="flex flex-grow items-center text-lg font-bold leading-none text-blue-900">
                      <font-awesome-icon
                        icon="pen"
                        size="sm" />
                      <span class="mx-3"
                        >Repasser mon test ({{
                          `${nbre_tentatives_restantes} ${nbre_tentatives_restantes > 1 ? 'tentatives restantes' : 'tentative restante'}`
                        }})</span
                      >
                    </div>
                  </template>
                  <template v-else-if="session.testValidation.repondu">
                    <div
                      class="flex flex-grow items-center text-lg font-bold leading-none text-blue-900">
                      <span>Note&nbsp;:&nbsp;</span>
                      <span class="tracking-wider">
                        {{ session.testValidation.nbreBonnesResponses }}/{{
                          session.testValidation.nbreQuestions
                        }}
                      </span>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <div
              v-if="
                session.type && session.type.id === 2 && session.moduleElearning
              "
              class="mb-3 flex flex-wrap rounded-lg bg-white p-6 shadow">
              <h2
                class="mb-8 mt-0 flex w-full border-l-4 border-jinius-green pl-6 text-3xl font-bold leading-none text-core-700">
                Module elearning
                <span
                  v-if="session.moduleElearning.statutString"
                  class="ml-2 text-lg font-normal italic text-core-500">
                  {{ `(${session.moduleElearning.statutString})` }}</span
                >
              </h2>
              <template
                v-if="
                  session.type &&
                  session.type.id === 2 &&
                  session.moduleElearning &&
                  session.moduleElearning.accessible
                ">
                <message-box
                  v-if="session.moduleElearning.showRetractation"
                  v-bind:source="`<p class='mb-1'>En tant que particulier, <strong>vous bénéficiez d'un droit de rétractation de 14 jours.</strong></p> <p>Pour accéder immédiatement à votre module Elearning avant la fin de la période de rétractation, vous avez la possibilité de renoncer à votre droit de rétractation en cliquant sur le bouton <span class='italic px-0.5'>Accéder à la formation</span>.</p><p>Si vous souhaitez utiliser ce droit, contactez l'organisateur à l'adresse suivante <a href='mailto:${session.organisateur.email}'>${session.organisateur.email}</p>`"
                  border_color="w-full border-jinius-blue" />

                <div
                  v-on:click="
                    () => openElearningModule(session.moduleElearning)
                  "
                  class="my-4 flex h-12 cursor-pointer items-center justify-center space-x-3 rounded bg-orange-500 px-6 text-center text-lg font-bold uppercase leading-none text-white shadow-md hover:bg-orange-600">
                  <font-awesome-icon
                    icon="external-link-alt"
                    size="sm" />
                  <span>Accéder à la formation</span>
                </div>
              </template>

              <div
                v-if="session.moduleElearning && session.moduleElearning.expire"
                class="mx-2 mb-4 flex w-full font-bold italic leading-none text-core-500">
                La durée d'accessibilité du module Elearning est dépassée. Le
                module n'est plus accessible.
              </div>
              <div
                v-for="(cours, index) in session.moduleElearning.cours"
                v-bind:key="`cours-${index}`"
                class="flex w-full space-x-4 p-3">
                <div
                  class="flex w-1/12 justify-center align-middle text-xl font-bold leading-none text-jinius-green">
                  <font-awesome-icon
                    size="2x"
                    icon="book-open" />
                </div>
                <div class="flex w-11/12 flex-wrap">
                  <div
                    class="mb-0.5 w-full break-all text-xl font-bold leading-none text-core-500">
                    {{ cours.titre }}
                  </div>
                  <div class="flex w-full">
                    {{ cours.statutString }}
                    {{ cours.score !== '0' ? cours.score + '%' : '' }}
                  </div>
                </div>
              </div>
              <div
                v-if="session.moduleElearning && session.moduleElearning.expire"
                class="flex flex-grow flex-wrap items-center justify-end">
                <div
                  class="rounded bg-jinius-red px-3 py-0.5 text-center text-sm font-bold uppercase text-white shadow-md">
                  <span class="align-middle"> Expiré </span>
                </div>
              </div>
            </div>

            <div
              v-if="
                ((sessionUrl && sessionUrl.length) ||
                  session.sessionUrlWebinaire) &&
                !session.programmes
              "
              class="mb-3 flex flex-wrap rounded-lg bg-white p-6 shadow">
              <h2
                class="mb-6 mt-0 flex w-full border-l-4 border-jinius-green pl-6 text-3xl font-bold leading-none text-core-700">
                Connexion
              </h2>
              <div
                v-on:click="openConnexionModal"
                v-if="sessionUrl && sessionUrl.length > 1"
                class="mb-1 ml-2 flex h-8 cursor-pointer rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase text-white shadow-md hover:bg-orange-600">
                <font-awesome-icon icon="external-link-alt" />
                <span class="ml-2 align-middle">Informations de connexion</span>
              </div>
              <div
                v-on:click="() => goToUrl(sessionUrl[0].url)"
                v-if="sessionUrl && sessionUrl.length === 1"
                class="mb-1 ml-2 flex h-8 cursor-pointer rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase text-white shadow-md hover:bg-orange-600">
                <font-awesome-icon icon="external-link-alt" />
                <span class="ml-2 align-middle">Accéder à la session</span>
              </div>
              <div
                v-on:click="() => goToUrl(session.sessionUrlWebinaire)"
                v-if="session.sessionUrlWebinaire"
                class="mb-1 ml-2 flex h-8 cursor-pointer rounded bg-orange-500 px-4 py-2 text-center text-sm font-bold uppercase text-white shadow-md hover:bg-orange-600">
                <font-awesome-icon icon="external-link-alt" />
                <span class="ml-2 align-middle">Accéder à la session</span>
              </div>
            </div>

            <div
              v-if="session.seances"
              class="mb-3 rounded-lg bg-white p-6 shadow">
              <h2
                class="mb-6 mt-2 border-l-4 border-jinius-green pl-3 text-2xl font-bold leading-none text-core-700">
                Séances
              </h2>
              <seance-description-card
                v-for="seance in session.seances"
                v-bind:key="seance.id"
                v-bind:seance="seance" />
            </div>

            <div
              v-if="session.programmes"
              class="mb-3 rounded-lg bg-white p-6 shadow">
              <div class="mb-6 mt-2 flex items-center justify-between">
                <h2
                  class="border-l-4 border-jinius-green pl-3 text-2xl font-bold leading-none text-core-700">
                  Programme
                </h2>

                <div
                  v-if="![4, 8].includes(session.type.id)"
                  v-on:click="onOpenModalAjoutCalendrier"
                  class="flex cursor-pointer items-center whitespace-nowrap rounded bg-jinius-dark-green px-6 py-2.5 font-bold leading-none text-white shadow hover:bg-opacity-90">
                  <font-awesome-icon
                    icon="calendar"
                    size="sm" />
                  <span class="ml-3">Ajouter au calendrier</span>
                </div>
              </div>
              <programme-list
                v-bind:programme="session.programmes"
                v-bind:classe_virtuelle="
                  session.classeVirtuelle ||
                  (session.type && [2, 3, 5].includes(session.type.id))
                "
                v-bind:is_formateur="true"
                v-bind:session_url_webinaire="session.sessionUrlWebinaire"
                v-bind:session_url="sessionUrl"
                v-bind:open_connexion_modal="openConnexionModal" />
            </div>
          </div>
          <div class="w-full lg:ml-2 lg:w-1/2">
            <div
              class="mb-3 rounded-lg bg-white p-6 shadow"
              v-if="
                session.certificat ||
                (session.support && !session.support.disabled) ||
                session.convocation ||
                session.factures ||
                session.attestation ||
                (session.documents && session.documents.length) ||
                (session.presences && session.presences.length)
              ">
              <h2
                class="mb-6 mt-0 border-l-4 border-jinius-green pl-3 text-2xl font-bold leading-none text-core-700">
                Ressources
              </h2>
              <div class="lg:mb-6 lg:ml-8">
                <div
                  v-if="session.convocation"
                  v-on:click="openConvocationModal"
                  class="ressources__download__link__container">
                  <h3 class="ressources__download__link__label">
                    Ma convocation
                  </h3>
                  <div class="ressources__download__link__button">
                    <div class="ressources__download__link__button__content">
                      <font-awesome-icon
                        class="text-xl"
                        icon="eye" />
                    </div>
                  </div>
                </div>

                <div
                  v-if="session.presences && session.presences.length === 1"
                  class="ressources__download__link__container"
                  v-on:click="downloadFeuillePresence(session.presences[0])">
                  <h3 class="ressources__download__link__label">
                    Feuille de présence de la session
                  </h3>
                  <div class="ressources__download__link__button">
                    <div class="ressources__download__link__button__content">
                      <font-awesome-icon
                        class="text-xl"
                        icon="download" />
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="session.presences && session.presences.length > 1"
                  class="mb-3 ml-8 flex w-full flex-wrap items-center">
                  <div class="flex w-full">
                    <h3
                      class="mb-2 text-xl font-bold leading-none text-core-700">
                      Feuille de présence de la session
                    </h3>
                  </div>
                  <div class="ml-4 flex w-full">
                    <ul class="list-inside list-disc">
                      <li
                        v-for="(presence, index) in presences"
                        v-bind:key="presence.seanceId"
                        class="ressources__download__link__container flex w-full"
                        v-on:click="downloadFeuillePresence(presence)">
                        <div class="ressources__download__link__label text-xs">
                          {{
                            `- Séance-${index + 1}${presence.nom ? ` : ${presence.nom}` : ''}`
                          }}
                        </div>
                        <div class="ressources__download__link__button">
                          <div
                            class="ressources__download__link__button__content">
                            <font-awesome-icon
                              class="text-xl"
                              icon="download" />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  v-if="session.attestation && session.attestation.url"
                  class="ressources__download__link__container"
                  v-on:click="
                    downloadAttestation(
                      session.attestation.url,
                      session.attestation.nom
                    )
                  ">
                  <h3 class="ressources__download__link__label">
                    Mon attestation d'animation
                  </h3>
                  <div class="ressources__download__link__button">
                    <div class="ressources__download__link__button__content">
                      <font-awesome-icon
                        class="text-xl"
                        icon="download" />
                    </div>
                  </div>
                </div>
                <div
                  class="mb-2 flex w-full justify-around"
                  v-if="session.support && !session.support.disabled">
                  <div class="mt-2 flex w-full">
                    <h3
                      class="ml-8 text-xl font-bold leading-none text-core-700">
                      Supports
                    </h3>
                  </div>
                  <div
                    v-if="supportsList.length > 1"
                    class="flex cursor-pointer items-center whitespace-nowrap rounded bg-jinius-dark-green px-6 py-2.5 font-bold leading-none text-white shadow hover:bg-opacity-90"
                    v-on:click="downloadSupports">
                    <font-awesome-icon
                      icon="download"
                      size="sm" />
                    <span class="ml-3"> Tout télécharger (.zip)</span>
                  </div>
                </div>
                <div
                  v-if="session.support"
                  class="mb-6">
                  <ag-grid-wrapper
                    v-bind:column_defs="[
                      {
                        headerName: 'Télécharger',
                        field: '',
                        cellRenderer: 'pdfDownloadCellRenderer',
                        cellRendererParams: {
                          session: session,
                          espace: espace,
                          openAppreciationModal: openAppreciationModal
                        }
                      },
                      {
                        headerName: 'Titre',
                        field: 'titre',
                        cellRenderer: 'supportTitreCellRenderer',
                        filter: false,
                        floatingFilter: false,
                        minWidth: 150
                      },
                      {
                        headerName: 'Type',
                        field: 'portailLabel',
                        cellRenderer: 'textCenterCellRenderer'
                      },
                      {
                        headerName: 'Version',
                        field: 'version',
                        cellRenderer: 'textCenterCellRenderer',
                        width: 80
                      },
                      {
                        headerName: 'Mis à jour le',
                        field: 'modifiedDate',
                        cellRenderer: 'textCenterCellRenderer'
                      },
                      {
                        headerName: 'Disponible jusqu\'au',
                        field: 'endDisponibiliteDate',
                        cellRenderer: 'textCenterCellRenderer'
                      }
                    ]"
                    v-bind:key="`supports-grid-${session.id}`"
                    v-if="supportsList.length"
                    v-bind:initial_data="supportsList"
                    v-bind:no_filters="true" />
                  <div
                    v-if="
                      supportsList.some((s) => s.obsolete) ||
                      supportsList.some((s) => s.provisoire)
                    "
                    class="status-label-wrapper">
                    <div
                      v-if="supportsList.some((s) => s.provisoire)"
                      class="flex items-center space-x-1">
                      <span class="status-label bg-info-500"></span>
                      <span class="text-xs font-bold">Provisoire</span>
                    </div>

                    <div
                      v-if="supportsList.some((s) => s.obsolete)"
                      class="flex items-center space-x-1">
                      <span class="status-label bg-jinius-red"></span>
                      <span class="text-xs font-bold">Obsolète</span>
                    </div>
                  </div>
                </div>

                <div
                  class="mb-2 flex w-full justify-around"
                  v-if="documentsList.length">
                  <div class="mt-2 flex w-full">
                    <h3
                      class="ml-8 text-xl font-bold leading-none text-core-700">
                      Autres ressources
                    </h3>
                  </div>
                  <div
                    v-if="documentsList.length > 1"
                    class="flex cursor-pointer items-center whitespace-nowrap rounded bg-jinius-dark-green px-6 py-2.5 font-bold leading-none text-white shadow hover:bg-opacity-90"
                    v-on:click="downloadDocuments">
                    <font-awesome-icon
                      icon="download"
                      size="sm" />
                    <span class="ml-3"> Tout télécharger (.zip)</span>
                  </div>
                </div>
                <div
                  v-if="documentsList.length"
                  class="mb-6">
                  <ag-grid-wrapper
                    v-bind:column_defs="[
                      {
                        headerName: 'Télécharger',
                        field: '',
                        cellRenderer: 'pdfDownloadCellRenderer',
                        cellRendererParams: {
                          session: session,
                          espace: espace,
                          openAppreciationModal: openAppreciationModal,
                          ignoreDisponibilite: true
                        }
                      },
                      {
                        headerName: 'Titre',
                        field: 'titre',
                        cellRenderer: 'supportTitreCellRenderer',
                        filter: false,
                        floatingFilter: false,
                        minWidth: 150
                      },
                      {
                        headerName: 'Mis à jour le',
                        field: 'modifiedDate',
                        cellRenderer: 'textCenterCellRenderer'
                      }
                    ]"
                    v-bind:key="`documents-grid-${session.id}`"
                    v-if="documentsList.length"
                    v-bind:initial_data="documentsList"
                    v-bind:no_filters="true" />
                </div>
              </div>
            </div>

            <div
              class="mb-3 rounded-lg bg-white p-6 shadow"
              v-if="session.effectifsCommuniques || !isParcoursOrCursus">
              <h2
                class="mb-6 mt-0 border-l-4 border-jinius-green pl-3 text-2xl font-bold leading-none text-core-700">
                Participants
              </h2>
              <div class="mb-4 flex flex-wrap space-x-2">
                <div
                  v-if="session.effectifsCommuniques"
                  class="flex h-24 w-24 flex-col space-y-2.5 rounded-md bg-accent-100 text-center text-core-700 shadow">
                  <div
                    class="flex h-1/2 w-full items-end justify-center px-2 text-sm leading-none">
                    <span class="leading-none">Effectif inscrit</span>
                  </div>

                  <div
                    class="flex h-1/2 w-full items-start justify-center text-2xl font-bold text-jinius-dark-green">
                    <span class="leading-none">{{
                      session.participants && session.participants.length
                        ? session.participants.length
                        : 0
                    }}</span>
                  </div>
                </div>

                <div
                  v-if="
                    session.participants &&
                    session.participants.length &&
                    session.participants.filter((p) => p.present).length
                  "
                  class="flex h-24 w-24 flex-col space-y-2.5 rounded-md bg-accent-100 text-center text-core-700 shadow">
                  <div
                    class="flex h-1/2 w-full items-end justify-center px-2 text-sm leading-none">
                    <span class="leading-none">Effectif présent</span>
                  </div>

                  <div
                    class="flex h-1/2 w-full items-start justify-center text-2xl font-bold text-jinius-dark-green">
                    <span class="leading-none">{{
                      session.participants.filter((p) => p.present).length
                    }}</span>
                  </div>
                </div>

                <div
                  v-if="moyenne_prerequis"
                  class="flex h-24 w-24 flex-col space-y-2.5 rounded-md bg-accent-100 text-center text-core-700 shadow">
                  <div
                    class="flex h-1/2 w-full items-end justify-center px-2 text-sm leading-none">
                    <span class="leading-none">Moyenne prérequis</span>
                  </div>

                  <div
                    class="flex h-1/2 w-full items-start justify-center text-2xl font-bold text-accent-500">
                    <span class="leading-none">{{ moyenne_prerequis }}</span>
                  </div>
                </div>
                <div
                  v-if="moyenne_acquis && session.terminee"
                  class="flex h-24 w-24 flex-col space-y-2.5 rounded-md bg-accent-100 text-center text-core-700 shadow">
                  <div
                    class="flex h-1/2 w-full items-end justify-center px-2 text-sm leading-none">
                    <span class="leading-none"
                      >Moyenne validation des acquis</span
                    >
                  </div>

                  <div
                    class="flex h-1/2 w-full items-start justify-center text-2xl font-bold text-accent-500">
                    <span class="leading-none">{{ moyenne_acquis }}</span>
                  </div>
                </div>
              </div>
              <div
                v-on:click="onOpenSessionDetailModal"
                v-if="!isParcoursOrCursus"
                class="white-space-normal my-4 flex w-full cursor-pointer items-center justify-center space-x-6 rounded bg-jinius-dark-green px-6 py-2.5 font-bold leading-none text-white shadow hover:bg-opacity-90">
                <font-awesome-icon
                  icon="chart-pie"
                  size="lg" />
                <span class="text-sm"
                  >Synthèse des appréciations des participants sur la
                  session</span
                >
              </div>
              <div
                class="flex flex-wrap"
                v-if="session.participants && session.participants.length">
                <ag-grid-wrapper
                  v-bind:key="`participants-grid-${session.id}`"
                  v-bind:column_defs="column_defs_participants"
                  v-bind:initial_data="
                    participants.map((p) => ({
                      ...p,
                      ...(p.statut && { statut: p.statut.label })
                    }))
                  " />
              </div>
            </div>
          </div>
        </div>
        <convocation-modal
          v-if="convocation_modal && !loading && session.convocation"
          v-bind:modal_show="convocation_modal"
          v-bind:onclose="closeConvocationModal"
          v-bind:ressource_base_url="baseUrl" />
        <satisfaction-modal
          v-if="
            session.satisfaction &&
            session.satisfaction.id &&
            satisfaction_modal
          "
          v-bind:evaluation_show="satisfaction_modal"
          v-bind:satisfaction="session.satisfaction"
          v-bind:session="session"
          v-bind:onclose="closeEvaluationModal"
          v-bind:fetch_data="fetch_session"
          v-bind:formateur="true" />

        <appreciation-modal
          v-bind:modal_show="appreciation_modal"
          v-bind:onclose="closeAppreciationModal"
          v-bind:elearning="session.elearning" />

        <contact-modal
          v-bind:modal_show="contact_modal"
          v-on:onclose="closeContactModal"
          v-bind:current_contact="
            session.contact ? session.contact : session.organisateur
          " />
        <connexion-modal
          v-bind:modal_show="connexion_modal"
          v-on:onclose="closeConnexionModal"
          v-bind:session_url="sessionUrl" />
        <elearning-modal
          v-bind:module_infos="session.moduleElearning"
          v-bind:show_modal="showElearningModal"
          v-bind:open_elearning_module="openElearningModuleModal"
          v-bind:onclose="closeElearningModal" />
        <elearning-question-modal
          v-bind:titre="session.titre"
          v-bind:participant_id="session.participantId"
          v-bind:plateforme_duree_acces="session.plateformeDureeAcces"
          v-bind:module_elearning="session.moduleElearning"
          v-bind:questions="
            session.elearningQuestion && session.elearningQuestion.questions
              ? session.elearningQuestion.questions
              : []
          "
          v-bind:autoriser_question="
            session.elearningQuestion &&
            session.elearningQuestion.autoriserQuestion
          "
          v-bind:show_modal="showElearningQuestionModal"
          v-bind:open_elearning_module="openElearningQuestionModal"
          v-bind:onclose="closeElearningQuestionModal"
          v-bind:refresh_session="refresh_session" />
        <session-details-modal
          v-if="sessionDetails"
          v-bind:show_modal="showSessionDetailsModal"
          v-bind:session="sessionDetails"
          v-bind:onclose="closeSessionDetailModal" />
        <session-participant-details-modal
          v-if="sessionParticipantDetails"
          v-bind:show_modal="showSessionParticipantDetailsModal"
          v-bind:participant="sessionParticipantDetails"
          v-bind:session="session"
          v-bind:client_id="client_id"
          v-bind:onclose="closeSessionParticipantDetailModal" />
        <support-modal
          v-bind:modal_show="showSupportModal"
          v-bind:onclose="closeSupportModal"
          v-bind:supports="supportAvecAppreciationRequise"
          v-bind:elearning="session.elearning" />
        <refonte-ajout-calendrier-modal
          v-bind:show="ajout_calendrier_modal"
          v-bind:reference="session.reference"
          v-bind:on_close="closeAjoutCalendrierModal"
          v-bind:title="session.titre"
          v-bind:description="session.programmes?.[0]?.prestations?.[0]?.site"
          v-bind:location="session.lieuNom"
          v-bind:start="session.dateHeureDebut"
          v-bind:end="session.dateHeureFin" />
        <refonte-modal-support-file-size-exceeded
          title="Téléchargement impossible"
          v-bind:show="support_file_size_exceeded_modal"
          v-bind:on_close="closeFileSizeModal" />
      </div>
    </div>
  </RefonteCard>
</template>

<script>
  import agGridWrapper from '@/components/utils/ag-grid/ag-grid-wrapper';
  import messageBox from '@/components/utils/message-box.vue';
  import programmeList from '@/components/utils/programme-list';
  import seanceDescriptionCard from '@/components/utils/seance-description-card.vue';
  import sessionCard from '@/components/utils/session-card.vue';
  import spinner from '@/components/utils/spinner.vue';
  import { API } from '@/http-common';
  import http_functions from '@/mixin/http_functions';
  import ConnexionModal from '@/views/_espace/connexion-modal';
  import contactModal from '@/views/_espace/contact-modal.vue';
  import sessionDetailsModal from '@/views/_espace/_formateur/_appreciations/_modal/session-details-modal';
  import sessionParticipantDetailsModal from '@/views/_espace/_formateur/_appreciations/_modal/session-participant-modal';
  import convocationModal from '@/views/_espace/_formateur/_sessions/_modal/convocation-modal';
  import satisfactionModal from '@/views/_espace/_formateur/_sessions/_modal/satisfaction-modal';
  import ElearningModal from '@/views/_espace/_participant/elearning-modal';
  import AppreciationModal from '@/views/_espace/_participant/_sessions/appreciation-modal';
  import ElearningQuestionModal from '@/views/_espace/_participant/_sessions/elearning-question-modal';
  import SupportModal from '@/views/_espace/_participant/_sessions/support-modal';
  import { compareDesc, parse } from 'date-fns';
  import RefonteCard from '@/components/refonte/cards/refonte-card.vue';
  import DetailHeader from './detail-header.vue';
  import DetailSiteInfo from './detail-site-info.vue';
  import RefonteAjoutCalendrierModal from '@/components/refonte/modals/ajout-calendrier-modal.vue';
  import RefonteModalSupportFileSizeExceeded from '@/components/refonte/modals/refonte-modal-support-file-size-exceeded.vue';
  import fileUpload from '@/components/utils/file-upload.vue';

  export default {
    components: {
      RefonteModalSupportFileSizeExceeded,
      seanceDescriptionCard,
      ElearningQuestionModal,
      ConnexionModal,
      AppreciationModal,
      spinner,
      sessionCard,
      contactModal,
      programmeList,
      agGridWrapper,
      convocationModal,
      satisfactionModal,
      ElearningModal,
      messageBox,
      sessionDetailsModal,
      sessionParticipantDetailsModal,
      SupportModal,
      RefonteCard,
      DetailHeader,
      DetailSiteInfo,
      RefonteAjoutCalendrierModal
    },
    mixins: [http_functions],
    props: {
      session: Object,
      client_id: Number,
      go_to_details: Function,
      fetch_session: Function,
      refresh_session: Function,
      open_elearning_module: Function
    },
    data: () => ({
      loading: false,
      support_file_size_exceeded_modal: false,
      convocation_modal: false,
      satisfaction_modal: false,
      examen_modal: false,
      validation_acquis_show: false,
      appreciation_modal: false,
      contact_modal: false,
      ajout_calendrier_modal: false,
      connexion_modal: false,
      showElearningModal: false,
      showElearningQuestionModal: false,
      showSessionDetailsModal: false,
      sessionDetails: null,
      showSessionParticipantDetailsModal: false,
      sessionParticipantDetails: null,
      showSupportModal: false,
      showDownloadAllModal: false,
      sessionParticipant: null,
      espace: 'formateur'
    }),
    computed: {
      fileUpload() {
        return fileUpload;
      },
      supportsList() {
        return this.session?.support?.supports || [];
      },
      documentsList() {
        return this.session?.documents || [];
      },
      baseUrl() {
        return `formateur/session/${this.session.reference}`;
      },
      isNewRuleStarted() {
        const breakpoint_date = new Date(2023, 6, 7);

        const is_match_today = compareDesc(breakpoint_date, new Date()) >= 0;

        const end_date = parse(this.session.dateFin, 'dd/MM/yyyy', new Date());

        const is_match_end_date = compareDesc(breakpoint_date, end_date) >= 0;

        return is_match_end_date && is_match_today;
      },
      column_defs_participants() {
        const columns = [
          {
            headerName: 'Nom',
            field: 'nom',
            filter: true,
            floatingFilter: true
          },
          {
            headerName: 'Prénom',
            field: 'prenom',
            filter: true,
            floatingFilter: true
          },
          {
            headerName: 'Poste',
            field: 'poste',
            filter: true,
            floatingFilter: true
          },
          {
            headerName: 'Note prérequis',
            field: 'notePositionnement',
            filter: true,
            floatingFilter: true,
            cellRenderer: 'textCenterCellRenderer'
          }
        ];

        if (this.session.terminee) {
          columns.push({
            headerName: 'Note validation des acquis',
            field: 'noteValidationAcquis',
            filter: true,
            floatingFilter: true,
            cellRenderer: 'textCenterCellRenderer'
          });
        }
        return columns;
      },
      isParcoursOrCursus() {
        return !!(this.session.produits && this.session.produits.length);
      },
      note_prerequis() {
        if (
          this.session &&
          this.session.testPositionnement &&
          this.session.testPositionnement.repondu &&
          (this.session.testPositionnement.nbreBonnesResponses ||
            this.session.testPositionnement.nbreBonnesResponses === 0) &&
          this.session.testPositionnement.nbreQuestions
        ) {
          const { nbreBonnesResponses, nbreQuestions } =
            this.session.testPositionnement;

          return `${nbreBonnesResponses}/${nbreQuestions}`;
        }

        return false;
      },
      note_validation_acquis() {
        if (
          this.session &&
          this.session.testValidation &&
          this.session.testValidation.repondu &&
          (this.session.testValidation.nbreBonnesResponses ||
            this.session.testValidation.nbreBonnesResponses === 0) &&
          this.session.testValidation.nbreQuestions
        ) {
          const { nbreBonnesResponses, nbreQuestions } =
            this.session.testValidation;

          return `${nbreBonnesResponses}/${nbreQuestions}`;
        }

        return false;
      },
      moyenne_prerequis() {
        if (this.session && this.session.participants) {
          return this.getMoyenne('testPositionnement');
        }

        return false;
      },
      moyenne_acquis() {
        if (this.session && this.session.participants) {
          return this.getMoyenne('testValidationAcquis');
        }

        return false;
      },
      participants() {
        return (
          this.session &&
          this.session.participants.map((participant) => {
            const { testPositionnement, testValidationAcquis } = participant;

            return {
              ...participant,
              notePositionnement: this.getNote(testPositionnement),
              noteValidationAcquis: this.getNote(testValidationAcquis)
            };
          })
        );
      },
      presences() {
        if (
          this.session &&
          this.session.presences &&
          this.session.presences.length > 1
        ) {
          const presences = [...this.session.presences];

          presences.sort((a, b) => a.ordre - b.ordre);

          return presences;
        }

        return this.session.presences;
      },
      sessionUrl() {
        if (this.session) {
          const { sessionUrlFormateur, sessionUrlParticipant } = this.session;

          if (sessionUrlFormateur && sessionUrlFormateur.length) {
            return sessionUrlFormateur;
          } else if (sessionUrlParticipant && sessionUrlParticipant.length) {
            return sessionUrlParticipant;
          } else {
            return [];
          }
        }

        return [];
      },
      supportAvecAppreciationRequise() {
        const { support } = this.session;

        return (
          support &&
          support.supports &&
          support.supports.filter((s) => s.participantAppreciationRequise)
        );
      }
    },
    methods: {
      async openElearningModuleModal() {
        await this.open_elearning_module();
        await this.closeElearningModal();
        await this.fetch_session();
      },
      openElearningModule(module) {
        if (module.showRetractation) {
          this.openElearningModal();
        } else {
          this.open_elearning_module();
        }
      },
      openElearningModal() {
        this.showElearningModal = true;
      },
      closeElearningModal() {
        this.showElearningModal = false;
      },
      openElearningQuestionModal() {
        this.showElearningQuestionModal = true;
      },
      closeElearningQuestionModal() {
        this.showElearningQuestionModal = false;
      },
      async downloadFile(url, nom) {
        const downloadUrl = `${import.meta.env.VITE_API_SAFIR}/${url}`;
        const fileLink = document.createElement('a');

        fileLink.href = downloadUrl;
        fileLink.setAttribute('download', nom);
        document.body.appendChild(fileLink);
        const simulateClick = function (elem) {
          // bubbles: false to avoid closing modal on download
          const evt = new MouseEvent('click', { bubbles: false });

          elem.dispatchEvent(evt);
        };

        simulateClick(fileLink);
        document.body.removeChild(fileLink);
      },
      getNote(test) {
        if (test) {
          const { nbreQuestions, nbreBonnesReponses } = test;

          return nbreBonnesReponses || nbreBonnesReponses === 0
            ? `${nbreBonnesReponses}/${nbreQuestions}`
            : 'Aucune notation';
        }

        return null;
      },
      getMoyenne(test) {
        if (test) {
          const notes = this.session.participants
            .map(
              (participant) =>
                participant[test] && participant[test].nbreBonnesReponses
            )
            .filter((nb) => nb === 0 || nb);

          if (notes && notes.length) {
            const sum = notes.reduce((a, b) => a + b, 0);
            const moyenne = Math.round((sum / notes.length) * 10) / 10;
            const nbreQuestions =
              this.session.participants[0][test].nbreQuestions;

            return `${moyenne}/${nbreQuestions}`;
          }
        }

        return null;
      },
      onOpenModalContact(id) {
        this.contact_modal = true;
      },
      onOpenModalAjoutCalendrier() {
        this.ajout_calendrier_modal = true;
      },
      onOpenSessionDetailModal() {
        this.sessionDetails = this.session;
        this.showSessionDetailsModal = true;
      },
      closeSessionDetailModal() {
        this.sessionDetails = null;
        this.showSessionDetailsModal = false;
      },
      onOpenSessionParticipantDetailModal(e, participant) {
        this.sessionParticipantDetails = participant;
        this.showSessionParticipantDetailsModal = true;
      },
      closeSessionParticipantDetailModal() {
        this.sessionParticipantDetails = null;
        this.showSessionParticipantDetailsModal = false;
      },
      closeContactModal() {
        this.contact_modal = false;
      },
      openAppreciationModal() {
        this.appreciation_modal = true;
      },
      closeAppreciationModal() {
        this.appreciation_modal = false;
      },
      openConnexionModal() {
        this.connexion_modal = true;
      },
      closeConnexionModal() {
        this.connexion_modal = false;
      },
      openConvocationModal() {
        this.convocation_modal = true;
      },
      closeConvocationModal() {
        this.convocation_modal = false;
      },
      openFileSizeModal() {
        this.support_file_size_exceeded_modal = true;
      },
      closeFileSizeModal() {
        this.support_file_size_exceeded_modal = false;
      },

      openEvaluationModal(session) {
        if (!session.satisfaction.dateReponse && session.satisfaction.id) {
          this.satisfaction_modal = true;
        }
      },
      isFileSizeExeeded(supports) {
        const totalSize = supports.reduce(
          (acc, cur) => acc + (cur.fileSize ? cur.fileSize : 0),
          0
        );
        return totalSize > 100 * 1000000; //100MB
      },
      closeEvaluationModal() {
        this.satisfaction_modal = false;
      },
      openExamenModal(session) {
        if (session.examen.id && !session.examen.termine) {
          this.examen_modal = true;
        }
      },
      closeExamenModal() {
        this.examen_modal = false;
      },
      goToUrl(url) {
        window.open(this.formatUrlProtocol(url), '_blank');
      },
      async downloadAttestation(url, nom) {
        const downloadUrl = `${import.meta.env.VITE_API_SAFIR}/${url}`;
        const fileLink = document.createElement('a');

        fileLink.href = downloadUrl;
        fileLink.setAttribute('download', nom);
        document.body.appendChild(fileLink);
        const simulateClick = function (elem) {
          // bubbles: false to avoid closing modal on download
          const evt = new MouseEvent('click', { bubbles: false });

          elem.dispatchEvent(evt);
        };

        simulateClick(fileLink);
        document.body.removeChild(fileLink);
      },
      closeValidationAcquisModal() {
        this.validation_acquis_show = false;
      },
      isTestValidationOuvrable(session) {
        return (
          session.testValidation.id &&
          !session.testValidation.reussi &&
          (!session.testValidation.repondu ||
            (session.testValidation.repassable &&
              (!session.testValidation.nbreTentativeSupplementaire ||
                session.testValidation.nbreTentativeSupplementaire + 1 <
                  session.testValidation.nbreTentatives)))
        );
      },
      openValidationAcquisModal(session) {
        if (this.isTestValidationOuvrable(session)) {
          this.validation_acquis_show = true;
        }
      },

      async downloadFeuillePresence(presence) {
        if (presence) {
          const { nom, titre, seanceId } = presence;
          const { sessionId, produitId, reference } = this.session;
          const isProduit = reference && reference.indexOf('-') > 0;
          const fileName = nom ? nom : titre;
          const response = await API.get(
            `formateur/session/${sessionId}/presence/${seanceId}/telechargement${isProduit ? `?parcoursProduitId=${produitId}` : ''}`,
            {
              responseType: 'blob',
              ...this.$header_skip_redirection
            }
          );
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `presence-${fileName
              .toLowerCase()
              .replaceAll(' ', '')
              .substr(0, 100)}.pdf`
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      },
      async downloadSupports() {
        const isElearning = this.session.type && this.session.type.id === 2;
        const sessionCondition =
          !isElearning &&
          this.supportAvecAppreciationRequise.length &&
          (!this.session.satisfaction ||
            !this.session.satisfaction.dateReponse);
        const elearningCondition =
          isElearning &&
          this.supportAvecAppreciationRequise.length &&
          !this.session.moduleElearning &&
          !this.session.moduleElearning.termine;

        if (sessionCondition || elearningCondition) {
          this.openSupportModal();
        } else {
          if (this.isFileSizeExeeded(this.supportsList)) {
            this.openFileSizeModal();
          } else {
            const downloadUrl = `${import.meta.env.VITE_API_SAFIR}${this.baseUrl}/supports`;
            const fileLink = document.createElement('a');

            fileLink.href = downloadUrl;
            fileLink.setAttribute('download', 'supports');
            document.body.appendChild(fileLink);
            const simulateClick = function (elem) {
              // bubbles: false to avoid closing modal on download
              const evt = new MouseEvent('click', { bubbles: false });

              elem.dispatchEvent(evt);
            };

            simulateClick(fileLink);
            document.body.removeChild(fileLink);
          }
        }
      },
      async downloadDocuments() {
        const downloadUrl = `${import.meta.env.VITE_API_SAFIR}${this.baseUrl}/documents`;
        const fileLink = document.createElement('a');

        fileLink.href = downloadUrl;
        fileLink.setAttribute('download', 'supports');
        document.body.appendChild(fileLink);
        const simulateClick = function (elem) {
          // bubbles: false to avoid closing modal on download
          const evt = new MouseEvent('click', { bubbles: false });

          elem.dispatchEvent(evt);
        };

        simulateClick(fileLink);
        document.body.removeChild(fileLink);
      },
      openSupportModal() {
        this.showSupportModal = true;
      },
      closeSupportModal() {
        this.showSupportModal = false;
      },
      openAjoutCalendrierModal() {
        this.ajout_calendrier_modal = true;
      },
      closeAjoutCalendrierModal() {
        this.ajout_calendrier_modal = false;
      },
      openDownloadAllModal() {
        this.showDownloadAllModal = true;
      },
      closeDownloadAllModal() {
        this.showDownloadAllModal = false;
      },
      goToDetails(reference) {
        if (reference) {
          this.$router.push(
            `/formateur/sessions-details?reference=${reference}`
          );
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .details__container {
    @apply w-full px-4 lg:pl-3 lg:pr-1;
    :deep(.aggrid__title) {
      @apply mb-3 ml-8 text-xl font-bold leading-none text-core-700;
    }

    .ressources__download__link__container {
      @apply mb-3 flex cursor-pointer items-center;

      .ressources__download__link__button {
        @apply ml-3 flex items-center;

        .ressources__download__link__button__content {
          @apply flex h-8 w-full items-center justify-center rounded bg-accent-200 p-4 text-center text-sm font-bold uppercase text-core-500 shadow-md disabled:cursor-not-allowed disabled:opacity-75;
        }
      }

      .ressources__download__link__label {
        @apply ml-8 text-xl font-bold leading-none text-core-700;
      }

      &:hover {
        .ressources__download__link__button {
          .ressources__download__link__button__content {
            @apply bg-accent-300 text-core-600;
          }
        }

        .ressources__download__link__label {
          @apply text-primary-800;
        }
      }
    }
  }

  :deep(.ressources__standalone_button__content) {
    @apply my-4 flex h-8 w-full items-center justify-center rounded bg-accent-200 p-4 text-center text-sm font-bold uppercase text-core-500 shadow-md disabled:cursor-not-allowed disabled:opacity-75;
    &:hover {
      @apply bg-accent-300 text-core-600;
    }
  }

  .status-label-wrapper {
    @apply mt-2 flex flex-wrap space-x-3;

    .status-label {
      @apply flex h-2 w-2 cursor-pointer rounded-full shadow;
    }
  }
</style>
